import { createAsyncAction, createAction } from 'react-async-client';

import {
    LOGOUT,
    LICENCE_CHECK,
    SESSION_OVER_LOGOUT,
    SAVE_BACK_URL,
    LOGIN,
    PASSWORD_CONFIRM,
    RECOVERY_PASSWORD
} from 'constants/actionTypes';

import { loginHandler, passwordConfirmHandler, recoveryPasswordHandler } from './handlers';

export const licenseCheck = createAction(LICENCE_CHECK);
export const logout = createAction(LOGOUT);
export const sessionOverLogout = createAction(SESSION_OVER_LOGOUT);
export const saveBackUrl = createAction(SAVE_BACK_URL);

export const login = createAsyncAction(LOGIN, loginHandler, {});
export const passwordConfirm = createAsyncAction(PASSWORD_CONFIRM, passwordConfirmHandler, {});
export const recoveryPassword = createAsyncAction(RECOVERY_PASSWORD, recoveryPasswordHandler, {});
